import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import LeadCard from '../../components/cards/LeadCard';

export function LeadKanbanCard({ lead, colId, onUpdate }) {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: lead._id,
        data: {
            colId,
            lead
        }
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        opacity: isDragging ? 0.4 : 1,
        cursor: 'grab',
        position: 'relative',
        zIndex: isDragging ? 999 : 1
    };

    return (
        <div ref={setNodeRef} style={style} {...listeners} {...attributes} className="relative group touch-manipulation">
            {/* EFEITO VISUAL QUANDO ARRASTA */}
            {isDragging && (
                <div className="absolute inset-0 bg-[var(--accent-color)]/20 border-2 border-[var(--accent-color)] rounded-2xl animate-pulse pointer-events-none" />
            )}
            
            <LeadCard lead={lead} onStatusUpdate={onUpdate} readOnly={true} />
        </div>
    );
}
